import { render } from "./client_department.vue?vue&type=template&id=abc7b5ce&scoped=true"
import script from "./client_department.vue?vue&type=script&lang=js"
export * from "./client_department.vue?vue&type=script&lang=js"

import "./client_department.vue?vue&type=style&index=0&id=abc7b5ce&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Private\\Edukatta_Private_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abc7b5ce"]])

export default __exports__